import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export type IpConfirmationDialogData = {
	title?: string;
	message: string;
} & any;

@Component({
    selector: 'ip-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class IpConfirmationDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<IpConfirmationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IpConfirmationDialogData
	) {}
}
